import React from 'react';
import { useTranslation } from 'react-i18next';

import { SkeletonProps } from '../../../interfaces/SkeletonProps';
import PageSection from '../../PageSection/PageSection';
import Refresh from '../../Refresh/Refresh';
import { SupporterDetailsPlaceholder } from '../../SupporterDetails/SupporterDetailsPlaceholder';

const AuctionLots: React.FunctionComponent<SkeletonProps> = ({
  animated,
  onRefresh,
  displayRefreshButton,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <PageSection title={'Auction Lots'} hasBorder>
      <Refresh
        onRefresh={onRefresh}
        displayRefreshButton={displayRefreshButton}
        buttonLabel={t('supporters.refresh')}
      >
        <SupporterDetailsPlaceholder animated={animated} />
      </Refresh>
    </PageSection>
  );
};

export default AuctionLots;
